import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { FormPT } from "./components/FormPT";
import "./styles/CreacionPT.css";

class CreacionPT extends Component {
    state = {
        idProductoTerminado: null,
    };

    componentDidMount() {
        const { match } = this.props;
        const idProductoTerminado = match.params.id;
        this.setState({ idProductoTerminado });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        let titulo = "Crear Producto Terminado";
        if (this.state.idProductoTerminado) {
            titulo = "Editar Producto Terminado";
        }

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="configuraciones_activo"
                    titulo={titulo}
                    subtitulo=""
                    col="12"
                >
                    <FormPT
                        idProductoTerminado={this.state.idProductoTerminado}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(CreacionPT);
